{
  "nav": {
    "home": "Acasă",
    "services": "Servicii",
    "prices": "Prețuri",
    "projects": "Proiecte",
    "about": "Despre Khromatik",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Înapoi la proiecte",
  "projectOverview": "Prezentare proiect",
  "overview": "Prezentare",
  "challenge": "Provocarea",
  "businessNeed": "Nevoia de afaceri",
  "philosophy": "Filosofia",
  "goal": "Obiectivul",
  "solution": "Soluția",
  "polestarLandingPage": "Pagina de destinație Polestar Live",
  "footer": {
    "legal": "Informații legale"
  },
  "whatsapp": {
    "label": "Scrie pe WhatsApp",
    "prefill": "Bună, aș vrea să discutăm despre un proiect video sau de branding."
  },
  "cookies": {
    "title": "Cookie-uri și confidențialitate",
    "body": "Folosim analize opționale (Google Analytics și Microsoft Clarity) pentru a înțelege cum este folosit site-ul. Puteți accepta sau respinge cookie-urile non-esențiale. Stocarea esențială păstrează limba și această alegere.",
    "learnMore": "Află mai mult",
    "accept": "Acceptă tot",
    "reject": "Respinge non-esențiale",
    "settings": "Setări cookie"
  }
}
